import {
    removeCurrentlyShownSuggestionFromEditor,
    fetchPersonalization,
    reportUsageForPersonalization,
    tryRemoveFirstCharacterFromSuggestion,
} from '../actions/smartComposePluginActions';
import { removeFirstCharacterFromSuggestion } from '../mutators/smartComposeMutators';
import {
    FEATURE_NAME,
    SUGGESTION_ACCEPTED,
    SUGGESTION_REJECTED,
    SAT,
    DSAT,
} from '../store/schema/PersonalizationConstants';
import { isFeatureEnabled } from 'owa-feature-flags';
import setTabPersonalizationSuggestion from '../actions/setTabPersonalizationSuggestion';
import { setCurrentlyShownSuggestion } from '../actions/smartComposePluginActions';
import store from '../store/store';
import removeSuggestionFromEditor from '../utils/removeSuggestionFromEditor';
import { orchestrator } from 'satcheljs';
import fetchSmartComposePersonalization from '../service/fetchSmartComposePersonalization';
import { SHOW_TAB, HIDE_TAB } from '../store/schema/PersonalizationConstants';
import { SignalInfo, ApplicationType } from 'owa-personalization';
import postPersonalizationUsageSignals from '../utils/postPersonalizationUsageSignals';
import { tabOutline } from 'owa-shared-post-boot';
import acceptSuggestion from '../utils/acceptSuggestion';
import { AcceptanceReason } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
import { trace } from 'owa-trace';

export const removeCurrentlyShownSuggestionFromEditorOrchestrator = orchestrator(
    removeCurrentlyShownSuggestionFromEditor,
    actionMessage => {
        const currentlyShownSuggestion = store().viewState.currentlyShownSuggestion;
        tabOutline.disable = false;
        if (currentlyShownSuggestion) {
            removeSuggestionFromEditor(
                actionMessage.editor,
                currentlyShownSuggestion.suggestionNode
            );
            setCurrentlyShownSuggestion(null);
        }
    }
);

export const fetchPersonalizationOrchestrator = orchestrator(
    fetchPersonalization,
    async actionMessage => {
        const response = await fetchSmartComposePersonalization();
        if (response === null) {
            // on failure: hide the tab hint
            setTabPersonalizationSuggestion(HIDE_TAB);
        } else if (response.length === 0) {
            // if there is no suggestion (i.e. new user) show the tab
            setTabPersonalizationSuggestion(SHOW_TAB);
        } else {
            // otherwise, look through the suggestions for an appropriate suggestion
            response.forEach(suggestion => {
                if (suggestion.action === SHOW_TAB || suggestion.action === HIDE_TAB) {
                    setTabPersonalizationSuggestion(suggestion.action);
                }
            });
        }
    }
);

export const reportUsageForPersonalizationOrchestrator = orchestrator(
    reportUsageForPersonalization,
    async actionMessage => {
        const {
            suggestionsAccepted,
            suggestionsRejected,
            dsatReported,
            satReported,
        } = actionMessage.sessionTelemetry;

        const postiveSignals: SignalInfo[] = [];
        const negativeSignals: SignalInfo[] = [];

        postiveSignals[SUGGESTION_ACCEPTED] = suggestionsAccepted ? suggestionsAccepted : 0;
        postiveSignals[SAT] = satReported ? satReported : 0;

        negativeSignals[SUGGESTION_REJECTED] = suggestionsRejected ? suggestionsRejected : 0;
        negativeSignals[DSAT] = dsatReported ? dsatReported : 0;

        if (isFeatureEnabled('mc-personalization')) {
            postPersonalizationUsageSignals(
                postiveSignals,
                negativeSignals,
                ApplicationType.Mail,
                FEATURE_NAME
            );
        }
    }
);

export const tryRemoveFirstCharacterFromSuggestionOrchestrator = orchestrator(
    tryRemoveFirstCharacterFromSuggestion,
    actionMessage => {
        const { editor, session } = actionMessage;
        const currentlyShownSuggestion = store().viewState.currentlyShownSuggestion;

        if (currentlyShownSuggestion.suggestionText.length > 1) {
            removeFirstCharacterFromSuggestion();
        } else if (currentlyShownSuggestion.suggestionText.length === 1) {
            removeFirstCharacterFromSuggestion();

            trace.info('[smartCompose] implicit acceptance of the suggestion');
            acceptSuggestion(
                editor,
                AcceptanceReason.TypedEverything,
                session,
                0 /* this means implicit accept */
            );
        }
    }
);
